/**
 * Created by chenggong on 2018/4/25.
 */
import * as types from './mutation-types'
import * as api from '../api/api'

export default {
  [types.SET_TOKEN] (state) {
    console.log('获取token(未使用)')
  },
  [types.SET_USERINFO] (state) {
    if (state.userInfo.token !== null) {
      api.getUserInfo().then(response => {
        let user = response.data
        if (user) {
          state.userInfo.name = user.name
          state.userInfo.code = user.code
          state.userInfo.department_list = user.department_list
          state.userInfo.department_code = user.department_code
          state.userInfo.seclevel = user.seclevel
        }
      }).catch(error => console.log(error))
    }
  },
  // 菜单
  [types.SET_NAVMENU] (state) {
    console.log('菜单功能(待开发)')
  },
  // DashBroad数据
  [types.SET_DASHBROAD] (state, params) {
    if (state.userInfo.token != null) {
      api.getDashBroad({params: params}).then(response => {
        state.dashBroad = response.data
      }).catch(error => console.log(error))
    }
  },
  // SaleIndex数据
  [types.SET_SALEINDEX] (state, params) {
    if (state.userInfo.token != null) {
      api.getSaleIndex({params: params}).then(response => {
        state.saleIndex = response.data
      }).catch(error => console.log(error))
    }
  },
  // SaleCategory
  [types.SET_SALECATEGORY] (state, params) {
    if (state.userInfo.token != null) {
      api.getSaleCategory({params: params}).then(response => {
        state.saleCategory = response.data
      }).catch(error => console.log(error))
    }
  },
  [types.SET_PRODUCTLIST] (state, params) {
    if (state.userInfo.token !== null) {
      api.getProductList(params).then(response => {
        state.product = response.data
      }).catch(error => console.log(error))
    }
  },
  // SaleOrderList
  [types.SET_SALEORDERLIST] (state, params) {
    if (state.userInfo.token != null) {
      api.getSaleOrder(params).then(response => {
        state.saleOrderList = response.data
      }).catch(error => console.log(error))
    }
  },
  // SaleOrderDetail
  [types.SET_SALEORDERDETAIL] (state, params) {
    if (state.userInfo.token != null) {
      api.getSaleOrder(params).then(response => {
        state.saleOrderDetail = response.data
      }).catch(error => console.log(error))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js